import React from 'react';
import { ClockIcon, FacebookIcon, InstagramIcon, MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS } from '../data/i18n';
import { serviceAreas } from '../data/serviceAreas';
import { services } from '../data/services';
import { Logo } from './Logo';
const companyLinks = [{
  href: '#about',
  labelKey: 'nav.about'
}, {
  href: '#gallery',
  labelKey: 'nav.gallery'
}, {
  href: '#contact',
  labelKey: 'nav.contact'
}];
const quickLinks = [{
  href: '#services',
  labelKey: 'nav.services'
}, {
  href: '#gallery',
  labelKey: 'nav.gallery'
}, {
  href: '#about',
  labelKey: 'nav.about'
}, {
  href: '#faq',
  labelKey: 'footer.faq'
}, {
  href: '#testimonials',
  labelKey: 'footer.testimonials'
}];
const linkClass = 'text-sm text-white/70 transition-colors duration-150 ease-smooth hover:text-white';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-navy-950 pb-10 pt-16 text-white" data-id="element-109" data-mp="3l9adtjp9964y">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-110" data-mp="3l9sgay2igglb">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-111" data-mp="3gbiliokp7i08">
          <div data-id="element-112" data-mp="3v89f2h7oxzhx">
            <Logo variant="light" data-id="element-113" data-mp="3v8rgds97n3wp" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/65" data-id="element-114" data-mp="3v5n5kc18p9x2">
              {t('footer.tagline')}
            </p>
            <a href={BUSINESS.phoneHref} className="mt-5 inline-flex items-center gap-2 font-display text-lg font-extrabold text-white hover:text-amber-400" data-id="element-115" data-mp="82qtvx6261vu">
              <PhoneIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-116" data-mp="hsk2cpawm0vv" />
              {BUSINESS.phoneDisplay}
            </a>

            <div className="mt-6" data-id="element-117" data-mp="cv1rgtdbtbl8">
              <span className="sr-only" data-id="element-118" data-mp="cvtlhzr9z19e">{t('footer.social')}</span>
              <ul className="flex items-center gap-3" data-id="element-119" data-mp="qub8twd9qbqs">
                <li data-id="element-120" data-mp="ms6fkyqqfh4o">
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 text-white transition-colors duration-150 ease-smooth hover:bg-white/20" data-id="element-121" data-mp="mspppta55185">
                    <InstagramIcon className="h-5 w-5" aria-hidden="true" data-id="element-122" data-mp="18kiwtacthlke" />
                  </a>
                </li>
                <li data-id="element-123" data-mp="1ckknypkxewlf">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 text-white transition-colors duration-150 ease-smooth hover:bg-white/20" data-id="element-124" data-mp="1cl2r8660ab2u">
                    <FacebookIcon className="h-5 w-5" aria-hidden="true" data-id="element-125" data-mp="3oc6p2sgvypwv" />
                  </a>
                </li>
                <li data-id="element-126" data-mp="3tarquwbsdhnf">
                  <a href={BUSINESS.whatsappHref} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="flex h-10 w-10 items-center justify-center rounded-lg bg-whats-500 text-white transition-colors duration-150 ease-smooth hover:bg-whats-600" data-id="element-127" data-mp="3tccee1zoo0bs">
                    <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-128" data-mp="1wpjtiucniof2" />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <nav aria-label={t('footer.company')} data-id="element-129" data-mp="2pdpg7mn9mnhj">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-amber-400" data-id="element-130" data-mp="2kdb5txy6z1gc">
              {t('footer.company')}
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5" data-id="element-131" data-mp="2fdf30218dg2d">
              {companyLinks.map(link => <li key={link.labelKey} data-id="element-132" data-mp="18yxpde5rpoac">
                  <a href={link.href} className={linkClass} data-id="element-133" data-mp="13z1hv4xv3eq1">
                    {t(link.labelKey)}
                  </a>
                </li>)}
            </ul>

            <h4 className="mt-7 font-display text-xs font-bold uppercase tracking-wide text-white/50" data-id="element-134" data-mp="2rug55jlhroqc">
              {t('footer.areas')}
            </h4>
            <ul className="mt-3 flex flex-col gap-2" data-id="element-135" data-mp="2ivuef15v93eh">
              {serviceAreas.map(area => <li key={area.id} data-id="element-136" data-mp="2ntcqv1j3e0r8">
                  <a href={area.href} className={linkClass} data-id="element-137" data-mp="2nue1j4w74l8f">
                    {area.name}
                  </a>
                </li>)}
            </ul>
          </nav>

          <nav aria-label={t('footer.services')} data-id="element-138" data-mp="3fk0qua91503b">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-amber-400" data-id="element-139" data-mp="31lj52i2opxo1">
              {t('footer.services')}
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5" data-id="element-140" data-mp="36j2i5ennc4ee">
              {services.map(service => <li key={service.id} data-id="element-141" data-mp="1q4svcoz1ynpo">
                  <a href="#services" className={linkClass} data-id="element-142" data-mp="1v5gww4kwqmy5">
                    {t(service.titleKey)}
                  </a>
                </li>)}
            </ul>
          </nav>

          <nav aria-label={t('footer.quick')} data-id="element-143" data-mp="1nnsddnnrtj0m">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-amber-400" data-id="element-144" data-mp="1ilteapz2d89h">
              {t('footer.quick')}
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5" data-id="element-145" data-mp="1wk9qgwfp3qz0">
              {quickLinks.map(link => <li key={link.labelKey} data-id="element-146" data-mp="13xyi2zluklrn">
                  <a href={link.href} className={linkClass} data-id="element-147" data-mp="13z06s6vsd6ru">
                    {t(link.labelKey)}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mt-12 text-sm font-semibold text-white/75" data-id="element-148" data-mp="1doteuxwpz3rc">{t('footer.areasText')}</p>

        <ul className="mt-6 grid grid-cols-1 gap-x-8 gap-y-4 border-t border-white/10 pt-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-149" data-mp="18w0d8iwjsbjh">
          <li className="flex items-start gap-3" data-id="element-150" data-mp="l5waedr6oftj">
            <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-151" data-mp="g8nsme9y6dst" />
            <span data-id="element-152" data-mp="2gawypqtrhw6h">
              <span className="block text-xs font-bold uppercase tracking-wide text-white/45" data-id="element-153" data-mp="2gbf3jbuhpiq0">
                {t('footer.phoneLabel')}
              </span>
              <a href={BUSINESS.phoneHref} className="mt-0.5 block text-sm font-semibold text-white hover:text-amber-400" data-id="element-154" data-mp="2l7dn8m4vick3">
                {BUSINESS.phoneDisplay}
              </a>
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-155" data-mp="1xd2tlnvr84td">
            <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-156" data-mp="22auo8pnsa519" />
            <span data-id="element-157" data-mp="279yub7fevmnd">
              <span className="block text-xs font-bold uppercase tracking-wide text-white/45" data-id="element-158" data-mp="279fo2nz4imp6">
                {t('footer.emailLabel')}
              </span>
              <a href={`mailto:${BUSINESS.email}`} className="mt-0.5 block break-all text-sm font-semibold text-white hover:text-amber-400" data-id="element-159" data-mp="2b9g0k32nwntl">
                {BUSINESS.email}
              </a>
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-160" data-mp="1b22jxjvxs3zq">
            <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-161" data-mp="171qyw5znw1nq" />
            <span data-id="element-162" data-mp="12b29cw7jler8">
              <span className="block text-xs font-bold uppercase tracking-wide text-white/45" data-id="element-163" data-mp="12aipvb28uib3">
                {t('footer.addressLabel')}
              </span>
              <span className="mt-0.5 block text-sm font-semibold text-white/80" data-id="element-164" data-mp="x9v2czd84jlm">
                {BUSINESS.area}
              </span>
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-165" data-mp="nd048hkv4l7v">
            <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-166" data-mp="jc6h3qf8vag1" />
            <span data-id="element-167" data-mp="je0zoy31mqgy">
              <span className="block text-xs font-bold uppercase tracking-wide text-white/45" data-id="element-168" data-mp="edd3zz3vdlge">
                {t('footer.hoursLabel')}
              </span>
              <span className="mt-0.5 block text-sm font-semibold text-white/80" data-id="element-169" data-mp="2dpfrrljj11zv">
                {t('footer.hoursLine')}
              </span>
            </span>
          </li>
        </ul>

        <div className="mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-170" data-mp="1hma9u86eiaum">
          <p className="text-xs text-white/55" data-id="element-171" data-mp="1mmo7qxeag4ex">{t('footer.rights')}</p>
          <p className="text-xs text-white/55" data-id="element-172" data-mp="17vfkuw1rsx5h">{t('footer.licensed')}</p>
        </div>
      </div>
    </footer>;
}